import React, { Fragment, useEffect, useState } from "react";
import useStyles from "./VendorPopUp.css";
import translation from "../../../i18n/i18.json";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useDispatch, useSelector } from "react-redux";
import AllActions from "../../../actions";
import { Company } from "../../../models/Company";
import { Po } from "../../../models/Po";
import { VendorUnBlockingService } from "../../../services/VendorUnBlockingService";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { FormError } from "../../../models/FormValidation/FormError";
import {
  InforDisplyaDuration,
  ResponseObjectType,
  VendorForm1Modes,
  FieldsLengthConstants,
  Max_PermittedPayee_For_Vendor,
  VendorTypeData,
  VendorCategoryData,
  FileUploadTypes,
  SpendManagedByData,
  RequestTypes
} from "../../../constants/AppConstants";
import {
  AmendRequestData,
  ExtendCompnayData,
  ExtendRequestData,
  VendorRequestChangeData,
} from "../../../models/VendorRequestChange/VendorRequestChangeData";
import { VendorExtendService } from "../../../services/VendorExtendService";
import { VendorAmendService } from "../../../services/VendorAmendService";
import { ReconAC } from "../../../models/ReconAC";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { PaymentMethod } from "../../../models/PaymentMethod";
import { HouseBank } from "../../../models/HouseBank";
import { CreditPeriodDays } from "../../../models/CreditPeriodDays";
import { SettlementCurrency } from "../../../models/SettlementCurrency";
import { TermsTrade } from "../../../models/TermsTrade";
import { VendorDetailPaymentMeta } from "../../../models/VendorDetail/VendorDetailPaymentMeta";
import { FormUtil } from "../../../utils/FormUtil";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import CancelIcon from "@material-ui/icons/Cancel";
import { SecondLevelCategory } from "../../../models/SecondLevelCategory";
import { VendorCreateState } from "../../../reducers/vendor/VendorCreateReducer";
import { RootState } from "../../../reducers";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import VendorSelectDialog from "./VendorSelectDialog";
import { SAPVendor } from "../../../models/SAPVendor";
import { Util } from "../../../utils/Util";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { Department } from "../../../models/Department";
import { User } from "../../../models/Master/User";
import { MasterDataService } from "../../../services/MasterDataService";
import { Country } from "../../../models/Country";
import { Common } from "../../../utils/Common";
import { RMCategory } from "../../../models/RMCategory";
import { ProcurementCategorySummary, ProcurementSubcategorySummary } from "../../../models/Master/ProcurementCategorySummary";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import { OnBoardingReason } from "../../../models/OnboardingReason";
import FileUpload from "../../FileUpload/FileUpload";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import { Approver1n2Data } from "../../../models/Approval/Approver1n2Data";
import { InstructionKey } from "../../../models/InstructionKey";
import VendorRequest from "../../../pages/Vendor/VendorRequest/VendorRequest";
import ValidationErrors from "../../ErrorList/ValidationErrors";
import { CopyAllRounded } from "@mui/icons-material";
import { MasterDataUtil } from "../../../utils/masterData/MasterDataUtil";
import { create } from "axios";

interface RequestExtendDialogProps {
  open: boolean;
  handleClose: any;
  requestMode: VendorForm1Modes;
  title: string;
  onUpdateConfirm: any;
  vendorId: number;
  vendorNo: string;
  countryCode?: string;
  companyCodeList: Array<Company>;
  departmentList: Array<Department>;
  companyCode: string;
  poCodeList: Array<string>;
  vendorType?: string;
  countries: Array<Country>;
  rmCategoryList: RMCategory[];
  procurementSubCategorySummaryList: ProcurementSubcategorySummary[];
  procurementCategoryList: ProcurementCategorySummary[];
  onboardingReasonList: OnBoardingReason[];
  instructionKeyList: InstructionKey[];
}

const icon = <CheckBoxOutlineBlankIcon />;
const checkedIcon = <CheckBoxIcon />;

export default function RequestExtendDialog(props: RequestExtendDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    open,
    handleClose,
    requestMode,
    title,
    onUpdateConfirm,
    vendorId,
    vendorNo,
    countryCode,
    companyCodeList,
    departmentList,
    companyCode,
    poCodeList,
    vendorType,
    countries,
    rmCategoryList,
    procurementSubCategorySummaryList,
    onboardingReasonList,
    instructionKeyList,
  } = props;
  const [poList, setPoList] = useState(Array<Po>());
  const createVendor: VendorCreateState = useSelector<RootState, VendorCreateState>((state) => state.vendorCreateDetails);
  const vendorDetail: VendorDetailState = useSelector<RootState, VendorDetailState>((state) => state.vendorDetails);
  const [openPermittedPayeeDialog, setOpenPermittedPayeeDialog] = useState(false);
  const [approver1List, setApprover1List] = useState(Array<User>());
  //const [approver2List, setApprover2List] = useState(Array<User>());
  const [approver1Lable, setApprover1Lable] = useState("");
  //const [approver2Lable, setApprover2Lable] = useState("");
  //const [spendManagedById, setSpendManagedById] = useState(Number);

  let initialState: ExtendRequestData = {
    departmentId: 0,
    vendorId: 0,
    vendorNo: props.vendorNo,
    accountingClarkEmail: "",
    accountingClark: "",
    comment: "",
    companyExtendDataList: [],
    rmCategoryIds: [],
    procurementCategoryIds: [],
    procurementSubcategoryIds: [],
    nmrpProcurementCategoryId: 0,
    nmrpProcurementSubcategoryId: 0,
    coCode: props.companyCode,
    poCode: props.poCodeList,
    firstApprovers: [],
    secondApprovers: []
  };

  let initialCompanyState: ExtendCompnayData = {
    coCode: "",
    poCode: [],
    reconACCode: "",
    paymentMethodCode: [],
    houseBankCode: "",
    creditPeriodDays: "",
    orderCurrency: "",
    alternativeCurrency: [],
    termsOfTrade: "",
    permittedPayeeList: [],
    houseBank: ""
  };

  const [vendorExtendRequest, setVendorExtendRequest] = useState<ExtendRequestData>(initialState);
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);

  const [selectedCoCodes, setSelectedCoCodes] = useState(Array<string>());
  const [selectedCompnayExtend, setSelectedExtendCompnay] = useState<ExtendCompnayData>(initialCompanyState);
  const [reconAcList, setReconAcList] = useState(Array<ReconAC>());
  const [paymentmethod, setPaymentmethod] = useState(Array<PaymentMethod>());
  const [housebanks, setHousebanks] = useState(Array<HouseBank>());
  const [crediperioddays, setCrediperioddays] = useState(Array<CreditPeriodDays>());
  const [settlementcurrency, setSettlementcurrency] = useState(Array<SettlementCurrency>());
  const [termstrade, setTermstrade] = useState(Array<TermsTrade>());

  const [secondCategories, setSecondCategories] = useState(Array<SecondLevelCategory>());
  const [procurementSubCategories, setProcurementSubCategories] = useState(Array<ProcurementSubcategorySummary>());
  const [rmCategories, setRMCategories] = useState(Array<RMCategory>());
  const [procurementCategories, setProcurementCategories] = useState(Array<ProcurementCategorySummary>());
  const [procurementSubCategorySummaries, setProcurementSubCategorySummaries] = useState(Array<ProcurementSubcategorySummary>());
  const [nmrpProcurementSubCategorySummaries, setNmrpProcurementSubCategorySummaries] = useState(Array<ProcurementSubcategorySummary>());
  const [nmrpProcurementCategories, setNmrpProcurementCategories] = useState(Array<ProcurementCategorySummary>());
  const [nmrpProcurementSubCategories, setNmrpProcurementSubCategories] = useState(Array<ProcurementSubcategorySummary>());
  const [vendorOnboardingReasons, setVendorOnboardingReasons] = useState(Array<OnBoardingReason>());
  const [openValidateErrDialog, setOpenValidateErrDialog] = useState(false);
  const [isProcurementEditable, setIsProcurementEditable] = useState(false);


  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };

  const clearApproverData = () => {
    setApprover1List([]);
    //setApprover2List([]);
    setApprover1Lable("");
    //setApprover2Lable("");
  }

  const getApproverData = (companyCode: string, vendorCategoryId: number, onBoardReasonIds: number[], isBulk: boolean, spendManagedById: number) => {
    return ApprovalPointUtil.getApproverData(companyCode, vendorCategoryId, onBoardReasonIds, isBulk
      , spendManagedById, RequestTypes.VendorExtend
      , (approver1n2Data: Approver1n2Data) => {
        setApprover1List(approver1n2Data.approver1List);
        //setApprover2List(approver1n2Data.approver2List);
        setApprover1Lable(approver1n2Data.approver1Lable);
        //setApprover2Lable(approver1n2Data.approver2Lable);
      });
  }

  const isOnboardingReasonActive = (reasonId: number) => {
    return (!createVendor.OnBoardReasonIds || createVendor.OnBoardReasonIds.length == 0
      || ApprovalPointUtil.isOnboardingReasonAllowed(createVendor.OnBoardReasonIds, reasonId))
      ? true : false;
  }

  //used only for amend
  const addMissingReconAc = (reconACData: Array<ReconAC>, reconAc: string) => {
    let matchingRecon = reconACData.find((recon) => {
      return recon.code === reconAc;
    });
    if (!matchingRecon) {
      reconACData.push({ code: reconAc, name: reconAc });
    }
  }

  const getExtendablePoCodes = (poData: Array<Po>) => {
    //if sample only allow samples. For bulk vendors allow both sample and bulk.
    var pos = Util.getSampleBulkPoList(poData, createVendor.VendorCategoryId, createVendor.IsBulk, RequestTypes.VendorExtend);
    if (selectedCompnayExtend.coCode == createVendor.CompanyCode) {
      return pos.filter(p => !(createVendor.PoCodes && createVendor.PoCodes.indexOf(p.code) > -1));
    } else {
      return pos;
    }
  }

  const getCompanyDataforExtend = () => {
    //dropdownDataRequestsCounter = 0;
    prepareForRequest();
    Promise.allSettled([
      VendorExtendService.getPO(
        vendorId,
        selectedCompnayExtend.coCode,
        function (poData: Array<Po>) {
          setPoList(getExtendablePoCodes(poData));
        },
        function (error: Error) {
          console.log(error);
          setPoList([]);
        }
      ),
      // getApproverData(selectedCompnayExtend.coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
      //   , createVendor.IsBulk, spendManagedById),
      VendorDetailService.getReconAC(
        selectedCompnayExtend.coCode,
        vendorType!,
        function (reconACData: Array<ReconAC>) {
          setReconAcList(reconACData);
        },
        function (error: Error) {
          console.log(error);
          setReconAcList([]);
        }
      ),
      countryCode
        ? VendorMasterData.getPreferedPaymentMethods(
          selectedCompnayExtend.coCode,
          countryCode,
          function (paymethodsList: Array<PaymentMethod>) {
            const i = paymethodsList.map(i => i.code).indexOf('H')
            if (i > 0) {
              const filtered = paymethodsList
              filtered.splice(i, 1)
              setPaymentmethod(filtered)
            } else {
              setPaymentmethod(paymethodsList);
            }

          },
          function (error: Error) {
            console.log(error);
            setPaymentmethod([]);
          }
        )
        : undefined,
      VendorMasterData.getHouseBank(
        selectedCompnayExtend.coCode,
        function (houseBankList: Array<HouseBank>) {
          setHousebanks(houseBankList);
        },
        function (error: Error) {
          console.log(error);
          setHousebanks([]);
        }
      ),
    ]).then(() => {
      compeleteRequest(true);
    });
  };

  useEffect(() => {
    if (selectedCompnayExtend.coCode) {
      getCompanyDataforExtend();
    } else {
      setPoList([]);
    }
  }, [selectedCompnayExtend.coCode]);

  useEffect(() => {
    if (vendorExtendRequest.procurementCategoryIds && vendorExtendRequest.procurementCategoryIds.length > 0) {
      //vendorExtendRequest.procurementSubcategoryIds = [];
      let procurementSubcats: ProcurementSubcategorySummary[] = [];
      procurementSubCategorySummaries.forEach(p => {
        if (vendorExtendRequest.procurementCategoryIds.find((e: number) => e == p.procurmentCategoryId)) {
          procurementSubcats.push(p);
        }
      });
      setProcurementSubCategories(procurementSubcats);
    } else {
      vendorExtendRequest.procurementSubcategoryIds = [];
      setProcurementSubCategories([]);
    }
  }, [vendorExtendRequest.procurementCategoryIds, procurementSubCategorySummaries]);

  useEffect(() => {
    if (vendorExtendRequest.nmrpProcurementCategoryId && vendorExtendRequest.nmrpProcurementCategoryId > 0) {
      let procurementSubcats: ProcurementSubcategorySummary[] = [];
      nmrpProcurementSubCategorySummaries.forEach(p => {
        if (vendorExtendRequest.nmrpProcurementCategoryId == p.procurmentCategoryId) {
          procurementSubcats.push(p);
        }
      });
      setNmrpProcurementSubCategories(procurementSubcats);
    } else {
      vendorExtendRequest.nmrpProcurementSubcategoryId = 0;
      setNmrpProcurementSubCategories([]);
    }
  }, [vendorExtendRequest.nmrpProcurementCategoryId, nmrpProcurementSubCategorySummaries]);

  useEffect(() => {
    if (fistSubmitDone) {
      validateDataToSave(false);
    }
  }, [vendorExtendRequest]);

  useEffect(() => {
    if (vendorExtendRequest.coCode && createVendor.VendorCategoryId > 0) {
      //if (!isInitialVendorDetailData) {
        //showLoadingMask();
        getApproverData(selectedCompnayExtend.coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
          , createVendor.IsBulk, createVendor.SpendManagedById || 0);
      //}
    } else {
      clearApproverData();
    }
  }, [createVendor.IsBulk, createVendor.SpendManagedById]);

  useEffect(() => {
    if (selectedCoCodes && selectedCoCodes.length > 0
    ) {
      //add new
      selectedCoCodes.forEach(c => {
        let existingCo = vendorExtendRequest.companyExtendDataList.find(f => f.coCode == c);
        if (!existingCo) {//add new
          vendorExtendRequest.companyExtendDataList.push({
            ...initialCompanyState,
            "coCode": c
          });
        }
      });
      //delete
      vendorExtendRequest.companyExtendDataList = vendorExtendRequest.companyExtendDataList.filter(c => {
        return selectedCoCodes.indexOf(c.coCode) > -1;
      });
      //approvers
      //TODO temp, later need to consider all companies      
      if (isRmOrNonRmOrServices()) {
        let coCode = selectedCoCodes && selectedCoCodes.length > 1
          ? selectedCoCodes[1] : selectedCoCodes[0];
        getApproverData(coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
          , createVendor.IsBulk, (createVendor.SpendManagedById || 0));
      } else {
        clearApproverData();
      }
    } else {
      clearApproverData();
    }
  }, [selectedCoCodes]);

  // const getOkButtonText = () => {
  //   switch (requestMode) {
  //     case VendorForm1Modes.VendorInialExtend:
  //       return translation.vendorchangepopup_extend_btn;
  //     case VendorForm1Modes.VendorInialAmend:
  //       return translation.vendorchangepopup_amend_btn;
  //     default:
  //       return "";
  //   }
  // };
  const copyCompanyExtend = (source: ExtendCompnayData, target: ExtendCompnayData, isCopyPo: boolean) => {
    if (isCopyPo) {
      target.poCode = [...source.poCode];
    }
    target.reconACCode = source.reconACCode;
    target.paymentMethodCode = [...source.paymentMethodCode];
    target.houseBankCode = source.houseBankCode;
    target.creditPeriodDays = source.creditPeriodDays;
    target.orderCurrency = source.orderCurrency;
    target.alternativeCurrency = [...source.alternativeCurrency];
    target.termsOfTrade = source.termsOfTrade;
    target.permittedPayeeList = [...source.permittedPayeeList];
    target.houseBank = source.houseBank;
  }

  const setCompanyExtendFromSelected = () => {
    var currentComanyExtend = vendorExtendRequest.companyExtendDataList.find(v => v.coCode == selectedCompnayExtend.coCode);
    if (currentComanyExtend) {
      copyCompanyExtend(selectedCompnayExtend, currentComanyExtend, true);
      // currentComanyExtend.poCode = [...selectedCompnayExtend.poCode];
      // currentComanyExtend.reconACCode = selectedCompnayExtend.reconACCode;
      // currentComanyExtend.paymentMethodCode = [...selectedCompnayExtend.paymentMethodCode];
      // currentComanyExtend.houseBankCode = selectedCompnayExtend.houseBankCode;
      // currentComanyExtend.creditPeriodDays = selectedCompnayExtend.creditPeriodDays;
      // currentComanyExtend.orderCurrency = selectedCompnayExtend.orderCurrency;
      // currentComanyExtend.alternativeCurrency = [...selectedCompnayExtend.alternativeCurrency];
      // currentComanyExtend.termsOfTrade = selectedCompnayExtend.termsOfTrade;
      // currentComanyExtend.permittedPayeeList = [...selectedCompnayExtend.permittedPayeeList];
      // currentComanyExtend.houseBank = selectedCompnayExtend.houseBank;
    }
  }

  const getCompanyVendorExtendData = (coCode: string) => {
    //set new company data
    var companyExtend = vendorExtendRequest.companyExtendDataList.find(v => v.coCode == coCode);
    if (!companyExtend) {
      companyExtend = {
        ...initialCompanyState,
        "coCode": coCode
      }
      vendorExtendRequest.companyExtendDataList.push(companyExtend);
    }
    return companyExtend;
  };

  const updateWithExistingVendorData = () => {
    //check vendor company is included in extend co list - if all extended, co will not appear in the list
    // let vendorCompany = companyCodeList.find(
    //   (company: Company) => {
    //     return company.code === companyCode;
    //   }
    // );
    let initialCompanyExtend = {
      "coCode": companyCode,
      "poCode": [],
      "reconACCode": vendorDetail.ReconAC,
      "paymentMethodCode": vendorDetail.PrefPayMethod,
      "houseBankCode": vendorDetail.HouseBank,
      "creditPeriodDays": vendorDetail.CreditPeriodDays,
      "orderCurrency": vendorDetail.orderCurrency,
      "alternativeCurrency": vendorDetail.alternativeCurrency,
      "termsOfTrade": vendorDetail.TermsOfTrade,
      "permittedPayeeList": vendorDetail.permittedPayeeList,
      "houseBank": vendorDetail.HouseBank
    };
    setIsProcurementEditable(!(createVendor.ProcurementSubcategoryIds && createVendor.ProcurementSubcategoryIds.length > 0));
    setSelectedCoCodes([companyCode]);
    setSelectedExtendCompnay({
      ...selectedCompnayExtend,
      ...initialCompanyExtend
    });
    //if (vendorCompany) {
      setVendorExtendRequest({
        ...vendorExtendRequest!,
        "vendorId": vendorId,
        "vendorNo": vendorNo,
        "poCode": poCodeList,
        "coCode": companyCode,
        "rmCategoryIds": [...createVendor.RMCategoryIds],
        "procurementCategoryIds": [...createVendor.ProcurementCategoryIds],
        "procurementSubcategoryIds": [...createVendor.ProcurementSubcategoryIds],
        "companyExtendDataList": [initialCompanyExtend],
        "accountingClarkEmail": vendorDetail.AccoutingEmail,
        "accountingClark": vendorDetail.AccoutingClark,
      });
    //}
  };

  const loadMasterData = () => {
    if (createVendor.VendorCategoryId == VendorCategoryData.RM) {
      getPromiseRMCategoryData(createVendor.VendorCategoryId);
    } else if (createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services) {
      getPromiseProcurmentSubcategoryData(createVendor.VendorCategoryId, false);
    }
  }

  const loadPaymentMetaData = (coCountryCode: string) => {
    VendorMasterData.getPaymentDetailMetaData(
      coCountryCode,
      function (paymentData: VendorDetailPaymentMeta) {
        setTermstrade(paymentData.termsOfTrades);
        setCrediperioddays(paymentData.creditPeriodDays);
        setSettlementcurrency(paymentData.settlementCurencies);
        compeleteRequest(true);
      },
      function (error: Error) {
        console.log(error);
        setTermstrade([]);
        setCrediperioddays([]);
        setSettlementcurrency([]);
        compeleteRequest(false);
      }
    );
  };

  const isRmOrNonRmOrServices = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services
      || createVendor.VendorCategoryId == VendorCategoryData.RM;
  };

  const isNonRmOrServices = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.NonRM
      || createVendor.VendorCategoryId == VendorCategoryData.Services;
  };

  const isProcurementSubCatComplete = () => {
    return procurementSubCategorySummaries.filter(v => vendorExtendRequest.procurementSubcategoryIds.indexOf(v.procurmentSubcategoryId) > -1)
      .map(v => v.procurmentCategoryId).filter((value, index, array) => array.indexOf(value) === index).length < vendorExtendRequest.procurementCategoryIds.length
      ? false : true;
  };

  const isServicesBySbu = () => {
    return createVendor.VendorCategoryId == VendorCategoryData.Services
      && (createVendor.SpendManagedById == SpendManagedByData.SBU
        || createVendor.SpendManagedById == SpendManagedByData.GroupProcurementAndSBU);
  };

  const handleEnter = () => {
    prepareForRequest();
    //setSpendManagedById(createVendor.SpendManagedById || 0);

    loadPaymentMetaData("");
    loadMasterData();
    updateWithExistingVendorData();
  };

  const handleExit = () => {
    setVendorExtendRequest(initialState);
    setFormErrors([]);
    setFistSubmitDone(false);
  };

  const getCompanyExtendSaveData = () => {
    var companyExtends = vendorExtendRequest.companyExtendDataList;
    var companyExtendObjs: {
      coCode: string;
      poCodes: string[];
      reconACCode: string;
      houseBankCode: string;
      creditPeriodDays: string;
      orderCurrency: string;
      termsOfTrade: string;
      paymentMethodCodes: string[];
      alternativeCurrencies: string[];
      permittedPayeeList: string[];
    }[] = [];
    //check is the user has selected company permission, if not, remove the selected company.
    var selectedCompany = companyCodeList.find(c => c.code == companyCode);
    companyExtends.forEach((ce) => {
      if ((selectedCompany || ce.coCode != companyCode)
        && (ce.coCode != createVendor.CompanyCode || (ce.poCode && ce.poCode.length > 0))) {//PO extend existing company
        companyExtendObjs.push({
          coCode: ce.coCode,
          poCodes: ce.poCode,
          reconACCode: ce.reconACCode,
          houseBankCode: ce.houseBankCode,
          creditPeriodDays: ce.creditPeriodDays,
          orderCurrency: ce.orderCurrency,
          termsOfTrade: ce.termsOfTrade,
          paymentMethodCodes: ce.paymentMethodCode,
          alternativeCurrencies: ce.alternativeCurrency,
          permittedPayeeList: ce.permittedPayeeList
        });
      }
    });
    return companyExtendObjs;
  };

  const getSaveData = () => {
    return {
      departmentId: vendorExtendRequest.departmentId,
      vendorNo: vendorExtendRequest.vendorNo,
      sourceCoCode: vendorExtendRequest.coCode,
      sourcePoCode: vendorExtendRequest.poCode,
      rmCategoryIds: vendorExtendRequest.rmCategoryIds,
      procurementCategoryIds: vendorExtendRequest.procurementCategoryIds,
      procurementSubcategoryIds: vendorExtendRequest.procurementSubcategoryIds,
      nmrpProcurementCategoryId: vendorExtendRequest.nmrpProcurementCategoryId,
      nmrpProcurementSubcategoryId: vendorExtendRequest.nmrpProcurementSubcategoryId,
      accountingClarkEmail: vendorExtendRequest.accountingClarkEmail,
      accountingClark: vendorExtendRequest.accountingClark,
      comment: vendorExtendRequest.comment,
      companyExtends: getCompanyExtendSaveData(),
      firstApprovers: vendorExtendRequest.firstApprovers,
      secondApprovers: vendorExtendRequest.secondApprovers
    }
  };

  const submitExtendRequest = () => {
    prepareForRequest();
    let toSave = getSaveData();
    if (toSave.companyExtends.length > 0) {
      VendorExtendService.submitVendorExtendRequest(
        getSaveData(),//get saved data
        function (vendorExtendData: any) {
          if (
            vendorExtendData &&
            vendorExtendData.resposeObjectType === ResponseObjectType.Error
          ) {
            compeleteRequest(false, vendorExtendData.message);
          } else {
            compeleteRequest(
              true,
              `${vendorExtendData.result} ${translation.vendorchangepopup_extend_sucess}`,
              InforDisplyaDuration.approvalStatus
            );
            onUpdateConfirm();
          }
        },
        function (error: Error) {
          console.log(error);
          compeleteRequest(false, translation.vendorchangepopup_extend_error_err);
        }
      );
    } else {
      compeleteRequest(false, translation.vendor_extend_not_selected_msg);
    }
  };

  const handleConfirm = () => {
    setFistSubmitDone(true);
    setCompanyExtendFromSelected();
    setOpenValidateErrDialog(false);
    if (validateDataToSave(true)) {
      submitExtendRequest();
    } else {
      setOpenValidateErrDialog(true);
    }
  };

  const handleCopy = () => {
    var validateResult = validateItem(selectedCompnayExtend);
    setOpenValidateErrDialog(false);
    if (validateResult.isValid) {
      vendorExtendRequest.companyExtendDataList.forEach(c => {
        if (selectedCompnayExtend.coCode != c.coCode && selectedCompnayExtend.coCode[0] == c.coCode[0]) {//
          copyCompanyExtend(selectedCompnayExtend, c, false);
        }
      });

    } else {
      setFormErrors(validateResult.errorsList);
      setOpenValidateErrDialog(true);
    }
  };

  const getPromiseRMCategoryData = (vendorCategoryId: number) => {
    return MasterMetaDataService.getRMCategories(
      function (userRmCategoryList: Array<RMCategory>) {
        setRMCategories(userRmCategoryList);
      },
      function () {
        setRMCategories([]);
      }
    );
  };
  const getPromiseOnboardingReasons = (vendorCategoryId: number) => {
    return MasterMetaDataService.getOnBoardingReasons(
      vendorCategoryId,
      function (onboardingReasonList: Array<OnBoardingReason>) {
        setVendorOnboardingReasons(onboardingReasonList);
      },
      function () {
        setVendorOnboardingReasons([]);
      }
    );
  };

  const loadProcurementCatList = (procurementCatList: ProcurementSubcategorySummary[], isNmrpExtend: boolean) => {
    let procurementCats: ProcurementCategorySummary[] = [];
    procurementCatList.forEach(p => {
      if (!procurementCats.find(e => e.procurmentCategoryId == p.procurmentCategoryId)) {
        procurementCats.push({
          vendorCategoryId: p.vendorCategoryId,
          procurmentCategoryId: p.procurmentCategoryId,
          procurmentCategoryName: p.procurmentCategoryName
        });
      }
    });
    if(isNmrpExtend){
      setNmrpProcurementCategories(Util.sortObjByString(procurementCats, "procurmentCategoryName") as ProcurementCategorySummary[]);
    } else {
      setProcurementCategories(Util.sortObjByString(procurementCats, "procurmentCategoryName") as ProcurementCategorySummary[]);
      setNmrpProcurementCategories([]);
    }   
  };

  const getPromiseProcurmentSubcategoryData = (vendorCategoryId: number, isNmrpExtend: boolean) => {
    return MasterDataService.getProcurementSubcategorySummaries(
      RequestTypes.VendorExtend,
      vendorCategoryId,
      function (procurementCatList: Array<ProcurementSubcategorySummary>) {
        if(isNmrpExtend){
          setNmrpProcurementSubCategorySummaries(Util.sortObjByString(procurementCatList, "procurmentCategoryName") as ProcurementSubcategorySummary[]);
        } else {
          setProcurementSubCategorySummaries(Util.sortObjByString(procurementCatList, "procurmentCategoryName") as ProcurementSubcategorySummary[]);
          setNmrpProcurementSubCategorySummaries([]);
        }
        loadProcurementCatList(procurementCatList, isNmrpExtend);
      },
      function () {
        if(isNmrpExtend){
          setNmrpProcurementSubCategorySummaries([]);
        }else {
          setProcurementSubCategorySummaries([]);
        }
      }
    );
  };


  const isCompanyExtendAllowed = (coList: string[]) => {
    //if source company po extended
    var originCoExtend = selectedCompnayExtend.coCode == companyCode
      ? selectedCompnayExtend
      : vendorExtendRequest.companyExtendDataList.find(v => v.coCode == companyCode);
    var isOriginPoExtended = originCoExtend?.poCode && originCoExtend?.poCode.length > 0;

    let otherCos = coList && coList.length > 0
      ? coList.filter(c => isOriginPoExtended || c != companyCode) : [];
    if (otherCos.length > 1 && otherCos.find(o => otherCos[0][0] != o[0])) {//First char same within cluster
      dispatch(AllActions.infoActions.openInforWarn(
        translation.vendor_extend_allow_multiselect_incluster_msg,
        InforDisplyaDuration.common
      ));
      return false
    }
    return true;
  }

  const isPoExtendAllowed = (pos: string[]) => {
    //if source company po extending
    if (selectedCompnayExtend.coCode == companyCode) {
      if (selectedCoCodes.length > 1 && selectedCoCodes.find(o => selectedCoCodes[0][0] != o[0])) {//First char same within cluster
        dispatch(AllActions.infoActions.openInforWarn(
          translation.vendor_extend_allow_multiselect_incluster_msg,
          InforDisplyaDuration.common
        ));
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  const handleChange = (input: string) => (e: any) => {
    if (input === "coCodes") {
      var selectedCos = e.target.value as string[];
      if (selectedCos.indexOf(companyCode) > -1 //avoiding deleting initial company
        && isCompanyExtendAllowed(selectedCos)) {//allow multiselect within cluster
        setSelectedCoCodes(e.target.value as string[]);
      }
    } else if (input === "coCode") {
      //if company code is same as vendor, then fill with exisiting details
      if (companyCode === e.target.value) {
        updateWithExistingVendorData();
      } else {
        setVendorExtendRequest({
          ...vendorExtendRequest!,
          "accountingClarkEmail": "",
          "accountingClark": "",
          [input]: e.target.value,
        });
      }
    } else if (input === "rmCategoryIds" ) {
      setVendorExtendRequest({ ...vendorExtendRequest!, [input]: e.target.value ? [e.target.value] : [] });
    } else if(input === "procurementSubcategoryIds") {
      let procSubCatId = e.target.value;
      if(procSubCatId > 0){
        let procCat = procurementSubCategorySummaries.find(p => p.procurmentSubcategoryId == procSubCatId);
        if(procCat){
          dispatch(AllActions.vendorCreationActions.updateDataField("SpendManagedById", procCat.spendManagedById));
        }
      }
      setVendorExtendRequest({ ...vendorExtendRequest!, [input]: procSubCatId ? [procSubCatId] : [] });
    } else if (input === "procurementCategoryIds") {
      setProcurementSubCategories([]);
      setVendorExtendRequest({
        ...vendorExtendRequest!
        , "procurementSubcategoryIds": []
        , [input]: e.target.value ? [e.target.value] : []
      });
    } else if (input === "nmrpProcurementCategoryId") {
      setNmrpProcurementSubCategories([]);
      setVendorExtendRequest({
        ...vendorExtendRequest!
        , "nmrpProcurementSubcategoryId": 0
        , [input]: e.target.value ? e.target.value : 0
      });
    }
     else {
      setVendorExtendRequest({ ...vendorExtendRequest!, [input]: e.target.value, });
    }
  };

  const handleServiceExtend = (pos: string[]) => {
    if (createVendor.VendorCategoryId == VendorCategoryData.Services && pos && pos.length > 0) {
      getPromiseProcurmentSubcategoryData(VendorCategoryData.NonRM, true);
      // setVendorExtendRequest({
      //   ...vendorExtendRequest,
      //   "nmrpProcurementCategoryId": 0,
      //   "nmrpProcurementSubcategoryId": 0,
      // });
      setIsProcurementEditable(true);
    } else {
      getPromiseProcurmentSubcategoryData(createVendor.VendorCategoryId, false);
      setVendorExtendRequest({
        ...vendorExtendRequest,
        "procurementCategoryIds": [...createVendor.ProcurementCategoryIds],
        "procurementSubcategoryIds": [...createVendor.ProcurementSubcategoryIds],
        "nmrpProcurementCategoryId": 0,
        "nmrpProcurementSubcategoryId": 0
      });
      setIsProcurementEditable(!(createVendor.ProcurementSubcategoryIds && createVendor.ProcurementSubcategoryIds.length > 0));
    }
  };

  const handleItemChange = (input: string) => (e: any) => {
    if (input === "poCode") {
      if (e.target.value == "") {
        setSelectedExtendCompnay({
          ...selectedCompnayExtend!,
          "orderCurrency": "",
          "alternativeCurrency": [],
          "termsOfTrade": "",
          [input]: e.target.value,
        });
      } else {
        var selectedPos = e.target.value as string[];
        if (isPoExtendAllowed(selectedPos)) {
          setSelectedExtendCompnay({ ...selectedCompnayExtend!, [input]: e.target.value, });
        }
      }
      handleServiceExtend(e.target.value);
    } else if (input === "paymentMethodCode") {
      if (selectedCompnayExtend.paymentMethodCode.length < 10) {
        setSelectedExtendCompnay({ ...selectedCompnayExtend!, [input]: e.target.value, });
      } else {
        dispatch(AllActions.infoActions.openInforWarn(
          `${translation.vendordetail_vendor_select_popup_slectedmax_msg} 10`,
          InforDisplyaDuration.common
        ));
      }
    } else {
      setSelectedExtendCompnay({ ...selectedCompnayExtend!, [input]: e.target.value, });
    }
  };

  const handleDelete = (e: React.MouseEvent, value: any, input: string) => {
    e.preventDefault();
    if (input === "coCodes") {
      if (value !== companyCode) { //do not allow to delete the initial company
        setSelectedCoCodes(selectedCoCodes.filter(c => c !== value));
        setVendorExtendRequest({
          ...vendorExtendRequest!
          , "companyExtendDataList": vendorExtendRequest.companyExtendDataList.filter(c => { return c.coCode !== value; })
        });
      }
    }
    else if (input === "poCode") {
      let pos = selectedCompnayExtend.poCode.filter((code: string) => { return code !== value; });
      setSelectedExtendCompnay({
        ...selectedCompnayExtend!
        , "poCode": pos
      });
      handleServiceExtend(pos);
    }
    else if (input === "firstApprovers") {
      setVendorExtendRequest({
        ...vendorExtendRequest!,
        "firstApprovers": vendorExtendRequest.firstApprovers.filter((email: string) => { return email !== value; })
      });
    }
    else if (input === "secondApprovers") {
      setVendorExtendRequest({
        ...vendorExtendRequest!,
        "secondApprovers": vendorExtendRequest.secondApprovers.filter((email: string) => { return email !== value; })
      });
    }
    else if (input === "paymentMethodCode") {
      setSelectedExtendCompnay({
        ...selectedCompnayExtend!,
        "paymentMethodCode": selectedCompnayExtend.paymentMethodCode.filter((code: string) => { return code !== value; })
      });
    } else if (input === "onBoardReasonIds") {
      setVendorExtendRequest({
        ...vendorExtendRequest!,
        "onBoardReasonIds": vendorExtendRequest.onBoardReasonIds.filter((id: number) => { return id !== value; })
      });
    } else if (input === "rmCategoryIds") {
      setVendorExtendRequest({
        ...vendorExtendRequest!,
        "rmCategoryIds": vendorExtendRequest.rmCategoryIds.filter((id: number) => { return id !== value; })
      });
    } else if (input === "procurementCategoryIds") {
      setVendorExtendRequest({
        ...vendorExtendRequest!,
        "procurementCategoryIds": vendorExtendRequest.procurementCategoryIds.filter((id: number) => { return id !== value; })
      });
    } else if (input === "procurementSubcategoryIds") {
      setVendorExtendRequest({
        ...vendorExtendRequest!,
        "procurementSubcategoryIds": vendorExtendRequest.procurementSubcategoryIds.filter((id: number) => { return id !== value; })
      });
    }
  };

  const getErrorState = (input: string) => {
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  const isPoRequired = (coCode: string) => {
    return (vendorType !== VendorTypeData.Employee
      && createVendor.CompanyCode != coCode //original CoCode may not extend to POs
      && (!isNewCopany(coCode) || vendorType === VendorTypeData.RMProductionRelated || vendorType === VendorTypeData.FixedAssetsConsumables))
      ? true : false;
  };

  const validateItem = (extendCompany: ExtendCompnayData) => {
    //To avoid wrong recon accounts in existing vendors
    let coCode = extendCompany.coCode;
    let existRecon = reconAcList.find((r) => {
      return r.code === extendCompany.reconACCode;
    });
    if (!existRecon) {
      extendCompany.reconACCode = "";
    }

    let validateFieldsData = [
      {
        fieldName: "poCode",
        isRequired: isPoRequired(extendCompany.coCode),
        reuiredMsg: coCode + "- Purcg Org is required",
        isList: true,
      },
      {
        fieldName: "reconACCode",
        isRequired: isNewCopany(extendCompany.coCode),
        reuiredMsg: coCode + "- ReconACCode code is required",
      },
      {
        fieldName: "paymentMethodCode",
        isRequired: isNewCopany(extendCompany.coCode),
        reuiredMsg: coCode + "- PaymentMethodCode is required",
        isList: true,
      },
      {
        fieldName: "houseBankCode",
        isRequired: false,
        reuiredMsg: coCode + "- HouseBankCode is required",
      },
      {
        fieldName: "creditPeriodDays",
        isRequired: true,
        reuiredMsg: coCode + "- Credit Period is required",
      },
      {
        fieldName: "orderCurrency",
        isRequired: (extendCompany.poCode && extendCompany.poCode.length > 0),
        reuiredMsg: coCode + "- Order Currency is required",
      },
      {
        fieldName: "alternativeCurrency",
        isRequired: false,
        reuiredMsg: coCode + "- Alternative Currency is required",
        isList: true,
      },
      {
        fieldName: "termsOfTrade",
        isRequired: (extendCompany.poCode && extendCompany.poCode.length > 0),
        reuiredMsg: coCode + "- TermsOfTrade is required",
      }
    ];
    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      extendCompany
    );
    return formValidateData;
  }

  const validateDataToSave = (isSubmit: boolean) => {
    setFormErrors([]);
    let validateFieldsData = [
      {
        fieldName: "departmentId",
        isRequired: true,
        reuiredMsg: "Department is required",
      },
      {
        fieldName: "rmCategoryIds",
        isRequired: createVendor.VendorCategoryId == VendorCategoryData.RM ? true : false,
        reuiredMsg: "RM Category is required",
        isList: true
      },
      {
        fieldName: "procurementCategoryIds",
        isRequired: isNonRmOrServices(),
        reuiredMsg: "Procurement Category is required",
        isList: true
      },
      {
        fieldName: "procurementSubcategoryIds",
        isRequired: isNonRmOrServices(),
        reuiredMsg: "Procurement Subcategory is required",
        isList: true
      },
      {
        fieldName: "firstApprovers",
        isRequired: isServicesBySbu(),
        reuiredMsg: approver1Lable + " required",
        isList: true,
      }
      // {
      //   fieldName: "secondApprovers",
      //   isRequired: !isRmOrNonRmOrServices(),
      //   reuiredMsg: approver2Lable + " required",
      //   isList: true,
      // }
    ];
    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      vendorExtendRequest
    );
    //company validation
    if (vendorExtendRequest.companyExtendDataList && vendorExtendRequest.companyExtendDataList.length > 0) {
      vendorExtendRequest.companyExtendDataList.forEach(e => {
        let formValidation = validateItem(e);
        if (!formValidation.isValid) {
          formValidation.errorsList.forEach(r => {
            formValidateData.errorsList.push({ fieldName: r.fieldName, errorMsg: r.errorMsg });
            formValidateData.isValid = false;
          });
        }
      });
    } else {
      formValidateData.errorsList.push({ fieldName: "Company Detail", errorMsg: "Company details required." });
      formValidateData.isValid = false;
    }

    //Proc sub cat list
    if (isNonRmOrServices()) {
      if (isSubmit && !isProcurementSubCatComplete()) {
        if (formValidateData.isValid) {
          dispatch(AllActions.infoActions.openInforError("Procurement Subcategories are incomplete.", InforDisplyaDuration.common));
        }
        formValidateData.errorsList.push({ fieldName: "Procurement Subcategory", errorMsg: "Procurement Subcategories are incomplete." });
        formValidateData.isValid = false;
      }
    }
    //if extending service vendor to Purchasing org, then nmrp procurement category/subcategory should be selected
    if (createVendor.VendorCategoryId == VendorCategoryData.Services && vendorExtendRequest.companyExtendDataList.find(c => c.poCode && c.poCode.length > 0)) {
      if (!(vendorExtendRequest.nmrpProcurementSubcategoryId > 0)) {
        formValidateData.errorsList.push({ fieldName: "NMRP Procurement Category", errorMsg: "NMRP Procurement Category is required." });
        formValidateData.isValid = false;
      }
    }

    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid;
  };

  const isPoAvailable = () => {
    return selectedCompnayExtend.poCode && selectedCompnayExtend.poCode.length > 0
      ? true
      : false;
  };

  const isNewCopany = (coCode: string) => {
    return coCode && coCode !== companyCode ? true : false;
  };

  const handlePermittedPayeeAddPress = () => {
    setOpenPermittedPayeeDialog(true);
  };

  const handlePermittedPayeeClose = () => {
    setOpenPermittedPayeeDialog(false);
  };

  const handleUpdatePermittedPayee = (sapVendorList: Array<SAPVendor>) => {
    setOpenPermittedPayeeDialog(false);
    if (sapVendorList && sapVendorList.length > 0) {
      setSelectedExtendCompnay({
        ...selectedCompnayExtend!,
        "permittedPayeeList": sapVendorList.map((row) => {
          return row.vendor;
        }),
      });
    } else {
      setSelectedExtendCompnay({
        ...selectedCompnayExtend!,
        "permittedPayeeList": [],
      });
    }
  };

  const handleChangeAutoCompete = (e: any, input: string, newValue: any) => {
    if (input === "alternativeCurrency") {
      let selectedCodeList: string[] = [];
      if (newValue) {
        selectedCodeList = newValue.map(function (item: SettlementCurrency) {
          return item.code;
        });
      }
      if (newValue) {
        setSelectedExtendCompnay({
          ...selectedCompnayExtend!,
          [input]: selectedCodeList,
        });
      } else {
        setSelectedExtendCompnay({
          ...selectedCompnayExtend!,
          [input]: [],
        });
      }
    } else if (input === "orderCurrency") {
      setSelectedExtendCompnay({
        ...selectedCompnayExtend!,
        "orderCurrency": newValue ? newValue.code : "",
        "alternativeCurrency": newValue
          ? selectedCompnayExtend.alternativeCurrency.filter((code: string) => {
            return code !== newValue.code;
          })
          : [],
      });
    }
  };

  const filterOptionsOrderCurrency = createFilterOptions({
    stringify: (option: SettlementCurrency) => option.name,
  });

  const isPORequest = () => {
    return createVendor.PoCodes && createVendor.PoCodes.length > 0;
  };

  const isFieldsAvailable = (fieldName: string) => {
    if (fieldName == "alternativeCurrency") {
      return Common.getSapSystem() != "S4";
    }
  }

  const getPrcurementSubcategoryName = (subCategoryId: number) => {
    let sc = procurementSubCategorySummaries.find(r => r.procurmentSubcategoryId == subCategoryId);
    return sc ? (sc.procurmentCategoryName + '-' + sc.procurmentSubcategoryName) : '';
  }

  const onTabsChange = (event: React.ChangeEvent<{}>, coCode: string) => {
    if (selectedCompnayExtend.coCode != coCode) {
      //set current company data
      setCompanyExtendFromSelected();
      //Load selected
      setSelectedExtendCompnay(getCompanyVendorExtendData(coCode));
      //Set approvers based on selected company
      getApproverData(coCode, createVendor.VendorCategoryId, createVendor.OnBoardReasonIds
          , createVendor.IsBulk, createVendor.SpendManagedById || 0);
    }
  }

  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        onEnter={handleEnter}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {title}
          {/* {translation.vendorchangepopup_unblock_title} */}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description"> */}
          <div>
            <div>
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_department_lbl}
                  </span>
                  <div className={classes.inputWrapper_Req}>
                    <Select
                      variant="outlined"
                      value={vendorExtendRequest.departmentId || ""}
                      onChange={handleChange("departmentId")}
                      error={getErrorState("departmentId")}
                    >
                      {departmentList.map((obj) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_comment_lbl}
                  </span>
                  <div className={classes.inputWrapper}>
                    <TextField
                      variant="outlined"
                      value={vendorExtendRequest.comment || ""}
                      onChange={handleChange("comment")}
                      error={getErrorState("comment")}
                      inputProps={{
                        maxLength: FieldsLengthConstants.RequestComments,
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }} >
                  <span className={classes.createLbl}>
                    {translation.vendorchangepopup_co_lbl}
                  </span>
                  <div className={classes.inputWrapper_Req}>
                    {/* <Select
                      variant="outlined"
                      value={vendorExtendRequest.coCode || ""}
                      onChange={handleChange("coCode")}
                      error={getErrorState("coCode")}>
                      {companyCodeList.map((obj) => (
                        <MenuItem key={obj.code} value={obj.code}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select> */}
                    <Select
                      variant="outlined"
                      multiple
                      value={selectedCoCodes}
                      onChange={handleChange("coCodes")}
                      error={getErrorState("coCodes")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as string[]).map((value) => (
                            <Chip
                              key={value}
                              label={value}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) =>
                                    event.stopPropagation()
                                  }
                                />
                              }
                              onDelete={(e) =>
                                handleDelete(e, value, "coCodes")
                              }
                              onClick={() => console.log("clicked chip")}
                            />
                          ))}
                        </div>
                      )}>
                      {companyCodeList.map((obj) => (
                        <MenuItem key={obj.code} value={obj.code}>
                          <Checkbox
                            checked={selectedCoCodes.includes(obj.code)}
                            disabled={companyCode == obj.code}
                          />
                          <ListItemText primary={obj.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>
                {createVendor.VendorCategoryId == VendorCategoryData.RM && (
                  <Fragment>
                    <Grid item container xs={12} sm={12} md={6} lg={4} >
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_BulkSample_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req} item xs={12} sm={12} md={12} lg={12} style={{ width: "50%", float: "left" }}>
                        <span>{createVendor.IsBulk ? "Bulk" : "Sample"}</span>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.vendor_crete_form1_RMCategory_lbl}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        <Select
                          variant="outlined"
                          value={vendorExtendRequest.rmCategoryIds[0] || 0}
                          onChange={handleChange("rmCategoryIds")}
                          inputProps={{ readOnly: createVendor.RMCategoryIds && createVendor.RMCategoryIds.length > 0 }}
                          error={getErrorState("rmCategoryIds")}
                        >
                          <MenuItem value="">
                            <em>{translation.dropdown_empty_text}</em>
                          </MenuItem>
                          {rmCategories.map((obj) => (
                            <MenuItem key={obj.id} value={obj.id}>
                              {obj.rmCategoryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </Fragment>)
                }
                {(createVendor.VendorCategoryId == VendorCategoryData.NonRM
                  || createVendor.VendorCategoryId == VendorCategoryData.Services
                ) && (
                    <Fragment>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>
                            {translation.vendor_crete_form1_procurement_cat_lbl}
                          </span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          <Select
                            variant="outlined"
                            value={vendorExtendRequest.procurementCategoryIds[0] || 0}
                            onChange={handleChange("procurementCategoryIds")}
                            inputProps={{ readOnly: !isProcurementEditable }}
                            error={getErrorState("procurementCategoryIds")}
                          >
                            <MenuItem value="">
                              <em>{translation.dropdown_empty_text}</em>
                            </MenuItem>
                            {procurementCategories.map((obj) => (
                              <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                                {obj.procurmentCategoryName}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>
                            {translation.vendor_crete_form1_procurement_subcat_lbl}
                          </span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          <Select
                            variant="outlined"
                            value={vendorExtendRequest.procurementSubcategoryIds[0] || 0}
                            onChange={handleChange("procurementSubcategoryIds")}
                            inputProps={{ readOnly: !isProcurementEditable }}
                            error={getErrorState("procurementSubcategoryIds")}
                          >
                            <MenuItem value="">
                              <em>{translation.dropdown_empty_text}</em>
                            </MenuItem>
                            {procurementSubCategories.map((obj) => (
                              <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                                {MasterDataUtil.getNameFromProcSubCategorName(obj.procurmentSubcategoryName)}
                              </MenuItem>
                            ))}
                          </Select>
                          <span className={classes.helpLbl}>{
                            MasterDataUtil.getSpendMngByFromProcSubCategorId(procurementSubCategories
                            ,vendorExtendRequest.procurementSubcategoryIds[0] || 0)}
                          </span>
                        </Grid>
                      </Grid>
                    </Fragment>)
                }
                {(createVendor.VendorCategoryId == VendorCategoryData.Services 
                  && nmrpProcurementCategories && nmrpProcurementCategories.length > 0) 
                  && (
                    <Fragment>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>
                            {translation.vendor_crete_form1_nmrp_procurement_cat_lbl}
                          </span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          <Select
                            variant="outlined"
                            value={vendorExtendRequest.nmrpProcurementCategoryId}
                            onChange={handleChange("nmrpProcurementCategoryId")}
                            inputProps={{ readOnly: !isProcurementEditable }}
                            error={getErrorState("nmrpProcurementCategoryId")}
                          >
                            <MenuItem value="">
                              <em>{translation.dropdown_empty_text}</em>
                            </MenuItem>
                            {nmrpProcurementCategories.map((obj) => (
                              <MenuItem key={obj.procurmentCategoryId} value={obj.procurmentCategoryId}>
                                {obj.procurmentCategoryName}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={4}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <span className={classes.createLbl}>
                            {translation.vendor_crete_form1_nmrp_procurement_subcat_lbl}
                          </span>
                        </Grid>
                        <Grid className={classes.inputWrapper_Req}>
                          <Select
                            variant="outlined"
                            value={vendorExtendRequest.nmrpProcurementSubcategoryId}
                            onChange={handleChange("nmrpProcurementSubcategoryId")}
                            inputProps={{ readOnly: !isProcurementEditable }}
                            error={getErrorState("nmrpProcurementSubcategoryId")}
                          >
                            <MenuItem value="">
                              <em>{translation.dropdown_empty_text}</em>
                            </MenuItem>
                            {nmrpProcurementSubCategories.map((obj) => (
                              <MenuItem key={obj.procurmentSubcategoryId} value={obj.procurmentSubcategoryId}>
                                {MasterDataUtil.getNameFromProcSubCategorName(obj.procurmentSubcategoryName)}
                              </MenuItem>
                            ))}
                          </Select>
                          <span className={classes.helpLbl}>{
                            MasterDataUtil.getSpendMngByFromProcSubCategorId(nmrpProcurementSubCategories
                            ,vendorExtendRequest.nmrpProcurementSubcategoryId)}
                          </span>
                        </Grid>
                      </Grid>
                    </Fragment>)
                }
                <Fragment>
                  <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} >
                    <Tabs value={selectedCompnayExtend.coCode || 0} onChange={onTabsChange}>
                      {selectedCoCodes.map((coCode) => (
                        <Tab label={coCode} value={coCode} />
                      ))
                      }
                    </Tabs>
                  </Grid>
                  {vendorType !== VendorTypeData.Employee && (
                    <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                      <span className={classes.createLbl}>
                        {translation.vendorchangepopup_po_lbl}
                      </span>
                      <div className={(isPoRequired(selectedCompnayExtend.coCode))
                        ? classes.inputWrapper_Req : classes.inputWrapper}>
                        <Select
                          variant="outlined"
                          multiple
                          value={selectedCompnayExtend.poCode || []}
                          onChange={handleItemChange("poCode")}
                          error={getErrorState("poCode")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) =>
                                        event.stopPropagation()
                                      }
                                    />
                                  }
                                  onDelete={(e) =>
                                    handleDelete(e, value, "poCode")
                                  }
                                  onClick={() => console.log("clicked chip")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {poList.map((obj) => (
                            <MenuItem key={obj.code} value={obj.code}>
                              <Checkbox
                                checked={selectedCompnayExtend.poCode.includes(
                                  obj.code
                                )}
                              />
                              <ListItemText primary={obj.name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>)}
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_recon_lbl}
                    </span>
                    <div className={isNewCopany(selectedCompnayExtend.coCode) ? classes.inputWrapper_Req : classes.inputWrapper}
                    >
                      <Select
                        disabled={!isNewCopany(selectedCompnayExtend.coCode)}
                        variant="outlined"
                        value={selectedCompnayExtend.reconACCode || ""}
                        onChange={handleItemChange("reconACCode")}
                        error={getErrorState("reconACCode")}
                      >
                        {reconAcList.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            {obj.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_payment_lbl}
                    </span>
                    <div className={isNewCopany(selectedCompnayExtend.coCode) ? classes.inputWrapper_Req : classes.inputWrapper}>
                      <Select
                        variant="outlined"
                        multiple
                        value={selectedCompnayExtend.paymentMethodCode || []}
                        onChange={handleItemChange("paymentMethodCode")}
                        error={getErrorState("paymentMethodCode")}
                        renderValue={(selected) => (
                          <div>
                            {(selected as string[]).map((value) => (
                              <Chip
                                key={value}
                                label={value}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) => event.stopPropagation()}
                                  />
                                }
                                onDelete={(e) => handleDelete(e, value, "paymentMethodCode")}
                              />
                            ))}
                          </div>
                        )}
                      >
                        {paymentmethod.map((obj: PaymentMethod) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            <Checkbox
                              checked={selectedCompnayExtend.paymentMethodCode.includes(obj.code)}
                            />
                            <ListItemText primary={obj.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {
                        translation.vendor_detail_paymentdetails_permittedpayee_lbl
                      }
                    </span>
                    <div className={classes.inputWrapper}>
                      <div className={classes.addBtnWrapper}>
                        <Button
                          onClick={handlePermittedPayeeAddPress}
                          disabled={!isNewCopany(selectedCompnayExtend.coCode)}
                        >
                          <AddCircleIcon></AddCircleIcon>
                          {
                            translation.vendor_detail_paymentdetails_permittedpay_addbtntxt
                          }
                        </Button>
                      </div>
                      {selectedCompnayExtend.permittedPayeeList && (
                        <span className={classes.textWrap}>
                          {Util.concateStringArray(
                            selectedCompnayExtend.permittedPayeeList
                          )}
                        </span>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_housebank_lbl}
                    </span>
                    <div className={classes.inputWrapper} >
                      <Select
                        disabled={!isNewCopany(selectedCompnayExtend.coCode)}
                        variant="outlined"
                        value={selectedCompnayExtend.houseBankCode || ""}
                        onChange={handleItemChange("houseBankCode")}
                        error={getErrorState("houseBankCode")}
                      >
                        {housebanks.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            {obj.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_creaditperd_lbl}
                    </span>
                    <div className={classes.inputWrapper_Req}>
                      <Select
                        variant="outlined"
                        value={selectedCompnayExtend.creditPeriodDays || ""}
                        onChange={handleItemChange("creditPeriodDays")}
                        error={getErrorState("creditPeriodDays")}
                      >
                        {crediperioddays.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            {obj.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_ordercrncy_lbl}
                    </span>
                    <div
                      className={
                        isPoAvailable()
                          ? classes.inputWrapper_Req
                          : classes.inputWrapper
                      }
                    >
                      <Autocomplete
                        disabled={!isPoAvailable()}
                        options={settlementcurrency.map(
                          (obj: SettlementCurrency) => obj
                        )}
                        getOptionLabel={(option) => option.code}
                        filterOptions={filterOptionsOrderCurrency}
                        onChange={(e, newValue) => {
                          e.preventDefault();
                          handleChangeAutoCompete(e, "orderCurrency", newValue);
                        }}
                        value={
                          settlementcurrency.find(
                            (element: SettlementCurrency) =>
                              element.code === selectedCompnayExtend.orderCurrency
                          ) || null
                        }
                        renderOption={(option) => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            variant="outlined"
                            error={getErrorState("orderCurrency")}
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_settlementcrncy_lbl}
                    </span>
                    <div className={classes.inputWrapper}>
                      <Autocomplete
                        disabled={!isPoAvailable() || !selectedCompnayExtend.orderCurrency}
                        multiple
                        options={settlementcurrency.filter(
                          (element: SettlementCurrency) => {
                            return (
                              selectedCompnayExtend.orderCurrency !== element.code
                            );
                          }
                        )}
                        disableCloseOnSelect
                        value={
                          settlementcurrency.filter((element) =>
                            selectedCompnayExtend.alternativeCurrency.includes(
                              element.code
                            )
                          ) || null
                        }
                        getOptionLabel={(option) => option.name}
                        onChange={(e, newValue) => {
                          e.preventDefault();
                          handleChangeAutoCompete(
                            e,
                            "alternativeCurrency",
                            newValue
                          );
                        }}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.name}
                          </React.Fragment>
                        )}
                        renderTags={(
                          value: SettlementCurrency[],
                          getTagProps
                        ) =>
                          value.map(
                            (option: SettlementCurrency, index: number) => (
                              <Chip
                                label={option.code}
                                {...getTagProps({ index })}
                              />
                            )
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            margin="normal"
                            error={getErrorState("alternativeCurrency")}
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "0 0px 10px", float: "left", }}>
                    <span className={classes.createLbl}>
                      {translation.vendorchangepopup_termstra_lbl}
                    </span>
                    <div
                      className={
                        isPoAvailable()
                          ? classes.inputWrapper_Req
                          : classes.inputWrapper
                      }
                    >
                      <Select
                        disabled={!isPoAvailable()}
                        variant="outlined"
                        value={selectedCompnayExtend.termsOfTrade || ""}
                        onChange={handleItemChange("termsOfTrade")}
                        error={getErrorState("termsOfTrade")}
                      >
                        {termstrade.map((obj) => (
                          <MenuItem key={obj.code} value={obj.code}>
                            {obj.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </Grid>
                </Fragment>
              </Grid>
              {approver1List && approver1List.length > 0 && (
                <Fragment>
                  <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} >
                    <span className={classes.popUpHeaderTxt}>
                      {translation.vendor_crete_form1_approvers_section_title}
                    </span>
                    <span className={classes.popUpHeaderLine}></span>
                  </Grid>
                  <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>{approver1Lable}</span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        {(!isRmOrNonRmOrServices() || isServicesBySbu()) && (<Select
                          variant="outlined"
                          multiple
                          value={vendorExtendRequest.firstApprovers || []}
                          onChange={handleChange("firstApprovers")}
                          error={getErrorState("firstApprovers")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />
                                  }
                                  onDelete={(e) => handleDelete(e, value, "firstApprovers")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {approver1List.map((obj) => (
                            <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                              <Checkbox
                                checked={vendorExtendRequest.firstApprovers.includes(obj.emailAddress)}
                              />
                              <ListItemText primary={obj.emailAddress} />
                            </MenuItem>
                          ))}
                        </Select>)}
                        {(isRmOrNonRmOrServices() && !isServicesBySbu()) && (
                          <span className={classes.textWrap}>
                            {`${approver1List.map((obj) => obj.emailAddress + ' ')}`}
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    {/* {approver2List.length > 0 && (<Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>{approver2Lable}</span>
                      </Grid>
                      <Grid className={classes.inputWrapper_Req}>
                        {!isRmOrNonRmOrServices() && (<Select
                          variant="outlined"
                          multiple
                          value={vendorExtendRequest.secondApprovers || []}
                          onChange={handleChange("secondApprovers")}
                          error={getErrorState("secondApprovers")}
                          renderValue={(selected) => (
                            <div>
                              {(selected as string[]).map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  clickable
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) => event.stopPropagation()}
                                    />
                                  }
                                  onDelete={(e) => handleDelete(e, value, "secondApprovers")}
                                />
                              ))}
                            </div>
                          )}
                        >
                          {approver2List.map((obj) => (
                            <MenuItem key={obj.emailAddress} value={obj.emailAddress}>
                              <Checkbox
                                checked={vendorExtendRequest.secondApprovers.includes(obj.emailAddress)}
                              />
                              <ListItemText primary={obj.emailAddress} />
                            </MenuItem>
                          ))}
                        </Select>)}
                        {isRmOrNonRmOrServices() && (
                          <span className={classes.textWrap}>
                            {`${approver2List.map((obj) => obj.emailAddress + ' ')}`}
                          </span>
                        )}
                      </Grid>
                    </Grid>)} */}
                  </Grid>
                </Fragment>)
              }
            </div>
          </div>
        </DialogContent>
        <div style={{ margin: "25px 0 0 0" }}>
          <DialogActions>
            <div style={{ margin: "20px ​10px 15px 0" }}>
              <div className={classes.greenBtnWrapper}>
                <Button onClick={handleConfirm} color="primary">
                  <CheckCircleIcon></CheckCircleIcon>
                  {translation.vendorchangepopup_extend_btn}
                </Button>
              </div>
              {/* )} */}
              <div className={classes.blueBtnWrapper}>
                <Button onClick={handleCopy} color="primary">
                  <CopyAllRounded></CopyAllRounded>
                  {translation.vendorchangepopup_copy_btn}
                </Button>
              </div>
              <div className={classes.grayBtnWrapper}>
                <Button onClick={handleClose} color="primary" autoFocus>
                  {translation.vendorchangepopup_close_btn}
                </Button>
              </div>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <VendorSelectDialog
        open={openPermittedPayeeDialog}
        title={translation.vendordetail_permittedvendor_popup_title}
        handleClose={handlePermittedPayeeClose}
        isEditmode={true}
        companyCode={vendorExtendRequest.coCode}
        onUpdateConfirm={handleUpdatePermittedPayee}
        alreadySelectedVendors={vendorExtendRequest.permittedPayeeList}
        nodataMsg={translation.vendordetail_permittedvendor_popup_nodta_msg}
        maxSelectItems={Max_PermittedPayee_For_Vendor}
        requestMode={requestMode}
        currentRequestVendor={createVendor.vendorNo}
      ></VendorSelectDialog>
      <ValidationErrors
        open={openValidateErrDialog}
        setOpen={setOpenValidateErrDialog}
        errorList={formErrors}
      ></ValidationErrors>
    </div>
  );
}
